export const I18N_NAMESPACE = "resources";
//# sourceMappingURL=constants.js.map